function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcsSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M3200.723,1637.501c-75.162-491.967-383.323-1096.382-992.13-1159.636 c0,0-462.235-56.223-917.898,28.99c-270.435,50.573-507.568,201.12-657.615,417.494 c-150.049,216.375-200.169,480.213-139.342,731.749c39.507,163.374,66.204,332.458,58.878,500.334 c-9.239,211.719-26.639,434.329,66.955,631.765c137.136,289.272,471.738,374.482,763.699,401.659 c107.589,10.014,215.578,14.052,323.262,22.565c206.579,16.333,438.246-10.098,637.349-63.881 C3358.56,2874.445,3275.885,2129.467,3200.723,1637.501z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4952.5327,
    y1: 1876.6504,
    x2: 5834.335,
    y2: 1876.6504,
    gradientTransform: "matrix(-1 0 0 1 6455.3057 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1502.773,1898.884c0,0-49.069-112.954-253.255-69.738 c-204.186,43.217-551.692-25.403-628.547-135.548c0,0,12.609,362.968,279.769,366.076 C1167.9,2062.781,1397.715,1811.592,1502.773,1898.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129178831998108724150000011262532416360001724_",
    gradientUnits: "userSpaceOnUse",
    x1: 5412.395,
    y1: 1941.6105,
    x2: 5458.3579,
    y2: 2293.9946,
    gradientTransform: "matrix(-1 0 0 1 6455.3057 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129178831998108724150000011262532416360001724_)"
    },
    d: "M923.43,1949.609 c197.873-7.199,432.699-177.414,579.343-50.725c-105.058-87.293-334.873,163.897-602.033,160.79 c-267.16-3.108-279.769-366.076-279.769-366.076S725.556,1956.808,923.43,1949.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030455654661115571280000000252725654994641568_",
    gradientUnits: "userSpaceOnUse",
    x1: 5882.1011,
    y1: 582.7341,
    x2: 5840.9639,
    y2: 766.9573,
    gradientTransform: "matrix(-0.9905 0.1373 0.1373 0.9905 6674.1631 -100.6993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030455654661115571280000000252725654994641568_)"
    },
    d: "M1004.53,1571.227 c0,0-31.638-119.528-11.607-165.568c24.746-14.466,17.197,74.967,17.197,74.967s9.795,86.464,17.818,103.843 C1035.961,1601.848,1004.53,1571.227,1004.53,1571.227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009572405491692368610000015714320083667142839_",
    gradientUnits: "userSpaceOnUse",
    x1: 5600.7563,
    y1: 755.9552,
    x2: 5451.4282,
    y2: 1424.6842,
    gradientTransform: "matrix(-0.9905 0.1373 0.1373 0.9905 6674.1631 -100.6993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009572405491692368610000015714320083667142839_)"
    },
    d: "M995.035,1516.699 c0.195,5.156,0.667,9.737,1.235,14.538c0.614,4.731,1.269,9.457,2.185,14.122c1.773,9.345,3.936,18.615,6.597,27.747 c5.417,18.224,12.342,36.055,20.963,53.088c17.218,34.06,40.699,65.145,68.914,91.083 c14.129,12.944,29.291,24.715,45.184,35.373c8.107,5.05,16.101,10.339,24.573,14.745l6.275,3.45l3.139,1.724l3.211,1.572 l12.854,6.267c2.127,1.084,4.315,2.018,6.507,2.946l6.562,2.815c4.394,1.823,8.703,3.882,13.19,5.446 c8.901,3.304,17.821,6.793,26.688,9.559c17.722,5.981,35.663,11.276,53.636,16.407c18.015,4.978,36.109,9.639,54.284,13.862 c18.193,4.126,36.429,7.945,54.667,11.529c18.242,3.545,36.452,6.984,54.615,10.285c18.156,3.334,36.228,6.715,54.092,10.58 c17.852,3.904,35.536,8.151,52.795,13.497c17.26,5.331,34.072,11.78,50.227,19.572c16.152,7.801,31.526,17.141,46.047,27.773 c14.485,10.678,28.112,22.645,40.869,35.6l0.034,0.035c2.545,2.585,6.705,2.617,9.289,0.071 c2.484-2.446,2.597-6.396,0.346-8.994c-12.36-14.196-25.823-27.59-40.586-39.558c-14.701-12.037-30.701-22.58-47.495-31.586 c-16.782-9.051-34.412-16.388-52.296-22.564c-17.895-6.174-36.052-11.234-54.248-15.586 c-36.402-8.718-72.781-15.575-108.808-23.134c-36.01-7.609-71.67-16.063-106.891-26.002 c-17.567-5.106-35.09-10.364-52.389-16.296c-8.767-2.826-17.104-6.006-25.562-9.082c-4.265-1.447-8.32-3.371-12.477-5.062 l-6.204-2.612c-2.074-0.86-4.145-1.725-6.144-2.734c-16.326-7.44-31.94-16.204-47.163-25.556 c-15.015-9.67-29.343-20.363-42.718-32.153c-3.263-3.032-6.661-5.928-9.875-9.015l-9.513-9.399l-9.061-9.84 c-2.94-3.351-5.75-6.816-8.639-10.219c-11.177-13.904-21.424-28.625-30.176-44.26c-8.677-15.657-16.341-31.964-22.352-48.918 c-3.079-8.45-5.716-17.062-7.982-25.762c-1.14-4.349-2.173-8.721-3.091-13.107c-0.885-4.329-1.705-8.914-2.197-12.981 l-0.036-0.298c-0.435-3.599-3.705-6.164-7.303-5.73C997.398,1510.347,994.918,1513.33,995.035,1516.699z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155124181331393383630000002381878613460474286_",
    gradientUnits: "userSpaceOnUse",
    x1: 5710.0244,
    y1: 602.3129,
    x2: 5838.1558,
    y2: 602.3129,
    gradientTransform: "matrix(-0.9905 0.1373 0.1373 0.9905 6674.1631 -100.6993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155124181331393383630000002381878613460474286_)"
    },
    d: "M995.735,1422.961 c0,0-63.749-222.138,50.043-262.023C1159.57,1121.054,999.837,1358.446,995.735,1422.961z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057853829879497254630000017110950794019141255_",
    gradientUnits: "userSpaceOnUse",
    x1: 6494.2744,
    y1: -558.6401,
    x2: 6420.7827,
    y2: -229.5246,
    gradientTransform: "matrix(-0.913 0.4079 0.4079 0.913 7064.939 -846.3923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057853829879497254630000017110950794019141255_)"
    },
    d: "M915.535,1373.487 c21.894,48.997,57.274,80.837,79.024,71.119c21.75-9.719,21.634-57.317-0.26-106.314 c-21.894-48.997-57.274-80.838-79.024-71.119C893.525,1276.892,893.641,1324.49,915.535,1373.487z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064313844958967297570000014961920057182634409_",
    gradientUnits: "userSpaceOnUse",
    x1: 6468.0132,
    y1: -2901.9272,
    x2: 6394.5225,
    y2: -2572.8164,
    gradientTransform: "matrix(-0.6486 0.7611 0.7611 0.6486 7273.4785 -1580.8199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064313844958967297570000014961920057182634409_)"
    },
    d: "M911.466,1529.491 c40.846,34.809,86.484,48.328,101.936,30.196c15.452-18.132-5.133-61.048-45.979-95.857 c-40.846-34.809-86.484-48.328-101.936-30.196C850.035,1451.766,870.62,1494.682,911.466,1529.491z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041255840647198257690000006426801627170970262_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.2827,
    y1: 2163.6187,
    x2: 602.7926,
    y2: 2492.7263,
    gradientTransform: "matrix(0.901 0.4338 -0.4338 0.901 1436.6288 -941.7109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041255840647198257690000006426801627170970262_)"
    },
    d: "M1097.339,1381.728 c-23.281,48.353-59.554,79.173-81.019,68.838c-21.464-10.335-19.992-57.91,3.289-106.263 c23.281-48.353,59.554-79.173,81.019-68.838C1122.093,1285.8,1120.62,1333.375,1097.339,1381.728z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143589791210821912950000008903232774976848806_",
    gradientUnits: "userSpaceOnUse",
    x1: 877.3514,
    y1: 2331.9153,
    x2: 803.8611,
    y2: 2661.0234,
    gradientTransform: "matrix(0.884 0.4675 -0.4675 0.884 1408.2019 -1049.2321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143589791210821912950000008903232774976848806_)"
    },
    d: "M1080.528,1502.558 c-25.094,47.437-62.507,76.863-83.565,65.723c-21.058-11.139-17.786-58.625,7.307-106.063 c25.094-47.438,62.507-76.863,83.565-65.724C1108.894,1407.635,1105.622,1455.121,1080.528,1502.558z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008120241149849636180000003998548602806538682_",
    gradientUnits: "userSpaceOnUse",
    x1: 5903.8892,
    y1: -4262.3286,
    x2: 5830.397,
    y2: -3933.2102,
    gradientTransform: "matrix(-0.4134 0.9105 0.9105 0.4134 7216.9717 -1997.9596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008120241149849636180000003998548602806538682_)"
    },
    d: "M954.86,1670.942 c48.865,22.187,96.461,22.589,106.31,0.897s-21.779-57.262-70.644-79.449c-48.865-22.187-96.461-22.588-106.31-0.897 C874.367,1613.185,905.995,1648.755,954.86,1670.942z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178914957655758418690000002233877836738474625_",
    gradientUnits: "userSpaceOnUse",
    x1: 3955.1938,
    y1: -6203.0698,
    x2: 3881.7048,
    y2: -5873.9673,
    gradientTransform: "matrix(0.0835 0.9965 0.9965 -0.0835 6823.373 -2684.8367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178914957655758418690000002233877836738474625_)"
    },
    d: "M1051.185,1793.885 c53.479-4.478,95.22-27.353,93.232-51.092c-1.988-23.74-46.952-39.354-100.43-34.877c-53.479,4.478-95.22,27.353-93.232,51.093 C952.742,1782.749,997.707,1798.363,1051.185,1793.885z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003098853263031236900000009726834940719064967_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.0933,
    y1: 1920.6334,
    x2: 144.6002,
    y2: 2249.7546,
    gradientTransform: "matrix(0.9471 0.3208 -0.3208 0.9471 1547.776 -364.9017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003098853263031236900000009726834940719064967_)"
    },
    d: "M1138.049,1605.366 c-17.219,50.828-49.469,85.836-72.032,78.193c-22.563-7.644-26.896-55.045-9.677-105.873 c17.219-50.828,49.469-85.836,72.032-78.193C1150.935,1507.137,1155.267,1554.538,1138.049,1605.366z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006688723564709775190000017781552051613472429_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.3762,
    y1: 1965.0453,
    x2: 231.8831,
    y2: 2294.1665,
    gradientTransform: "matrix(0.9471 0.3208 -0.3208 0.9471 1547.776 -364.9017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006688723564709775190000017781552051613472429_)"
    },
    d: "M1206.467,1675.429 c-17.219,50.828-49.469,85.836-72.032,78.193c-22.563-7.644-26.896-55.045-9.677-105.873 c17.219-50.828,49.469-85.836,72.032-78.193C1219.353,1577.199,1223.686,1624.601,1206.467,1675.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000223992713095173490000006707977471091810491_",
    gradientUnits: "userSpaceOnUse",
    x1: -619.5262,
    y1: -7627.5723,
    x2: -829.3127,
    y2: -6688.0942,
    gradientTransform: "matrix(0.7394 0.6733 0.6733 -0.7394 6689.1675 -3263.4128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000223992713095173490000006707977471091810491_)"
    },
    d: "M1406.553,2119.949 c4.725-4.801,8.687-9.387,12.781-14.271c3.993-4.871,7.947-9.781,11.639-14.918c7.444-10.221,14.51-20.792,21.054-31.773 c12.974-22.028,24.387-45.32,33.708-69.714c18.658-48.757,29.567-101.566,31.876-154.851 c1.115-26.643,0.305-53.348-2.134-79.842c-1.61-13.17-2.905-26.433-5.411-39.419l-1.68-9.785l-0.843-4.893l-1.042-4.835 l-4.199-19.333c-0.65-3.241-1.49-6.414-2.339-9.584l-2.507-9.526c-1.737-6.323-3.185-12.768-5.24-18.96 c-3.887-12.464-7.614-25.114-11.983-37.062c-8.305-24.284-17.43-48.192-26.737-71.988 c-9.485-23.705-19.331-47.211-29.655-70.414c-10.43-23.136-21.185-46.044-32.165-68.745 c-11.019-22.67-22.112-45.213-33.3-67.581c-11.15-22.391-22.191-44.733-32.609-67.285 c-10.371-22.573-20.287-45.272-28.827-68.497c-8.555-23.211-15.7-46.94-21.056-71.161c-5.346-24.226-8.622-48.991-10.004-73.995 c-1.31-25.006-0.725-50.243,1.48-75.428l0.007-0.068c0.44-5.025-2.807-9.503-7.251-9.999c-4.271-0.478-8.098,2.919-8.781,7.642 c-3.692,25.867-5.757,52.199-5.449,78.651c0.195,26.448,2.826,52.954,7.538,78.94c4.659,26.014,11.608,51.408,19.856,76.039 c8.258,24.642,17.776,48.57,27.995,71.911c20.433,46.704,42.607,91.725,63.842,136.996 c21.173,45.296,41.271,90.972,59.618,137.501c9.01,23.34,17.841,46.767,25.86,70.555c4.234,11.896,7.794,23.646,11.548,35.432 c1.991,5.851,3.366,11.902,5.041,17.856l2.417,8.962c0.821,2.984,1.634,5.97,2.254,9.007c5.825,24.091,9.835,48.6,12.98,73.214 c2.682,24.674,3.854,49.527,3.238,74.335c-0.297,6.191-0.36,12.406-0.748,18.593l-1.397,18.549l-2.171,18.458 c-0.853,6.13-1.918,12.223-2.861,18.343c-4.348,24.342-10.202,48.416-18.098,71.705c-7.976,23.229-17.366,45.953-28.669,67.485 c-5.569,10.821-11.639,21.314-18.085,31.487c-3.217,5.094-6.538,10.094-9.966,14.983c-3.398,4.803-7.09,9.764-10.551,13.913 l-0.254,0.304c-3.062,3.672-2.913,9.454,0.333,12.916C1398.682,2123.08,1403.457,2123.077,1406.553,2119.949z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014630001176400791570000007387256919383190972_",
    gradientUnits: "userSpaceOnUse",
    x1: 5765.8999,
    y1: -4031.9919,
    x2: 5673.3159,
    y2: -3617.3777,
    gradientTransform: "matrix(-0.5419 0.8405 0.8405 0.5419 7432.9214 -1648.7885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014630001176400791570000007387256919383190972_)"
    },
    d: "M1154.225,1160.056 c55.533,40.478,113.435,50.698,129.328,22.827c15.893-27.871-16.242-83.28-71.774-123.758 c-55.533-40.478-113.435-50.698-129.328-22.827C1066.557,1064.169,1098.692,1119.577,1154.225,1160.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093884731307994077200000015856463461427642044_",
    gradientUnits: "userSpaceOnUse",
    x1: 1436.7979,
    y1: 2115.5195,
    x2: 1339.5688,
    y2: 2550.9358,
    gradientTransform: "matrix(0.8329 0.5534 -0.5534 0.8329 1383.0518 -1552.496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093884731307994077200000015856463461427642044_)"
    },
    d: "M1377.923,1110.154 c-36.566,62.22-86.014,97.782-110.443,79.43c-24.429-18.353-14.59-83.67,21.976-145.89 c36.566-62.22,86.014-97.782,110.443-79.43C1424.328,982.616,1414.489,1047.933,1377.923,1110.154z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064329985085985728680000009387435276607957951_",
    gradientUnits: "userSpaceOnUse",
    x1: -729.7303,
    y1: 135.0198,
    x2: -831.5569,
    y2: 591.0259,
    gradientTransform: "matrix(0.996 0.0891 -0.0891 0.996 2081.0825 578.7953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064329985085985728680000009387435276607957951_)"
    },
    d: "M1306.95,929.94 c-5.889,74.406-34.346,132.328-63.56,129.372c-29.214-2.956-48.122-65.67-42.233-140.076 c5.889-74.406,34.346-132.328,63.56-129.372C1293.931,792.82,1312.84,855.534,1306.95,929.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173120621067545747880000008740581564972314277_",
    gradientUnits: "userSpaceOnUse",
    x1: 5216.1318,
    y1: -4893.8325,
    x2: 5125.2026,
    y2: -4486.6279,
    gradientTransform: "matrix(-0.3387 0.9409 0.9409 0.3387 7417.769 -1995.3263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173120621067545747880000008740581564972314277_)"
    },
    d: "M1224.427,1336.276 c62.169,25.3,120.619,20.516,130.552-10.686c9.933-31.202-32.411-77.006-94.58-102.306 c-62.169-25.3-120.619-20.516-130.552,10.686C1119.913,1265.172,1162.258,1310.976,1224.427,1336.276z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017514793827099319130000006045715855145306298_",
    gradientUnits: "userSpaceOnUse",
    x1: 1565.0919,
    y1: 2201.252,
    x2: 1467.8632,
    y2: 2636.668,
    gradientTransform: "matrix(0.8329 0.5534 -0.5534 0.8329 1383.0518 -1552.496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017514793827099319130000006045715855145306298_)"
    },
    d: "M1437.334,1252.558 c-36.566,62.22-86.013,97.782-110.443,79.43s-14.59-83.67,21.976-145.89c36.566-62.22,86.014-97.782,110.443-79.43 C1483.74,1125.021,1473.901,1190.338,1437.334,1252.558z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098908436110109272620000016583490762790972845_",
    gradientUnits: "userSpaceOnUse",
    x1: 5302.0967,
    y1: -4688.8447,
    x2: 5211.1675,
    y2: -4281.6401,
    gradientTransform: "matrix(-0.3387 0.9409 0.9409 0.3387 7417.769 -1995.3263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098908436110109272620000016583490762790972845_)"
    },
    d: "M1289.101,1474.056 c62.169,25.3,120.619,20.516,130.552-10.686c9.933-31.202-32.411-77.006-94.58-102.306 c-62.169-25.3-120.619-20.516-130.552,10.686C1184.588,1402.951,1226.932,1448.755,1289.101,1474.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052794842349790946980000004472474139661876642_",
    gradientUnits: "userSpaceOnUse",
    x1: 912.3804,
    y1: 1880.0602,
    x2: 813.3417,
    y2: 2323.5811,
    gradientTransform: "matrix(0.9097 0.4152 -0.4152 0.9097 1467.3365 -829.0884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052794842349790946980000004472474139661876642_)"
    },
    d: "M1500.86,1369.756 c-27.437,67.958-71.309,111.887-97.991,98.116c-26.682-13.77-26.071-80.024,1.366-147.982 c27.436-67.958,71.308-111.887,97.991-98.116C1528.907,1235.543,1528.296,1301.797,1500.86,1369.756z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036240246482416692420000008445552701974742461_",
    gradientUnits: "userSpaceOnUse",
    x1: 5444.4185,
    y1: -4569.9775,
    x2: 5353.4893,
    y2: -4162.7729,
    gradientTransform: "matrix(-0.3387 0.9409 0.9409 0.3387 7417.769 -1995.3263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036240246482416692420000008445552701974742461_)"
    },
    d: "M1352.739,1648.226 c62.169,25.3,120.619,20.516,130.552-10.686c9.933-31.202-32.411-77.006-94.58-102.306 c-62.169-25.3-120.619-20.516-130.552,10.686C1248.225,1577.122,1290.57,1622.926,1352.739,1648.226z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126288403769121157170000001532202884938556599_",
    gradientUnits: "userSpaceOnUse",
    x1: 1042.5947,
    y1: 2012.0883,
    x2: 943.556,
    y2: 2455.6091,
    gradientTransform: "matrix(0.9097 0.4152 -0.4152 0.9097 1467.3365 -829.0884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126288403769121157170000001532202884938556599_)"
    },
    d: "M1564.498,1543.927 c-27.436,67.958-71.308,111.886-97.991,98.116c-26.682-13.77-26.071-80.024,1.366-147.983 c27.436-67.958,71.308-111.886,97.991-98.116C1592.545,1409.714,1591.934,1475.968,1564.498,1543.927z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2487.055,1147.43c12.451-20.876,550.086-435.808,550.086-435.808l120.378,107.68 c35.109,31.405,51.85,78.403,45.604,128.024l-49.14,390.377l-253.81,1286.793c-11.03,55.923-49.868,106.049-103.172,133.158 l-153.264,77.948L2487.055,1147.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180353404132845969820000001771113815093896112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.6266,
    y1: 2738.0405,
    x2: 2923.5774,
    y2: 151.1561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180353404132845969820000001771113815093896112_)"
    },
    d: "M2956.796,691.277l-1317.764,83.611 c-66.423,4.214-127.099,65.752-136.129,137.486l-53.45,424.613c-0.453,3.596-0.769,7.188-0.95,10.767l-64.206,1276.368 c-3.433,68.257,41.455,124.986,103.773,130.474l1079.959,95.119c73.838,6.503,143.19-45.608,158.834-119.975l297.416-1413.797 c0.847-4.027,1.525-8.062,2.033-12.096l59.952-476.262C3096.394,747.125,3038.057,686.121,2956.796,691.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1492.194,2721.852c-46.568-3.983-80.809-47.084-78.251-98.122l64.132-1279.244 c0.135-2.687,0.375-5.416,0.715-8.115l53.571-425.574c6.796-53.985,52.658-100.364,102.58-103.409l1317.356-80.355 c60.911-3.716,104.674,42.265,97.088,102.527l-59.8,475.06c-0.38,3.013-0.892,6.064-1.524,9.07l-296.377,1410.289 c-11.633,55.356-64.151,94.98-119.188,90.272L1492.194,2721.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2731.614,915.466l-948.997,46.23c-76.382,3.721-145.983,72.818-156.249,154.372l-28.716,228.125 c-0.515,4.089-0.874,8.172-1.074,12.24l-56.903,1151.027c-3.831,77.496,47.9,141.494,119.672,147.189l744.22,59.049 c81.02,6.428,157.287-52.118,174.592-134.795l260.891-1246.451c0.936-4.468,1.685-8.946,2.249-13.422l31.44-249.758 C2883.978,979.982,2820.344,911.143,2731.614,915.466z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2779.591,875.194c-350.75-59.93-693.87-40.386-1029.909,52.905 c-62.877,17.456-108.577,85.293-100.813,149.421l43.721,361.13c6.261,51.719,45.366,87.552,95.606,87.237l780.314-4.901 c56.748-0.356,111.663-39.46,133.472-95.389l154.766-396.888C2884.692,957.046,2849.242,887.095,2779.591,875.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1796.531,1459.674c-22.389,0.252-39.951-15.695-42.771-38.764l-44.33-362.615 c-1.692-13.836,2.082-28.425,10.634-41.093c8.61-12.755,20.876-21.837,34.554-25.569 c160.915-43.909,325.594-70.704,489.516-79.006c167.923-8.505,340.053,2.151,511.68,32.389 c14.976,2.638,26.829,11.28,33.357,24.343c6.499,13.002,6.805,28.599,0.859,43.898l-153.542,395.109 c-9.622,24.762-33.975,42.24-59.155,42.523L1796.531,1459.674z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080915526814390383470000014905723287760345749_",
    gradientUnits: "userSpaceOnUse",
    x1: 2607.1887,
    y1: 977.7305,
    x2: 2168.4929,
    y2: 2219.1438,
    gradientTransform: "matrix(1 0 -0.1238 0.9835 -169.9759 -22.8047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080915526814390383470000014905723287760345749_)"
    },
    d: "M2202.358,1244.515 c86.863-2.311,162.97,29.501,217.769,84.11l216.014-227.923c-101.645-96.335-240.757-150.302-397.697-142.866 c-153.439,7.27-298.22,72.127-413.511,172.032l144.715,207.837C2034.92,1282,2116.58,1246.797,2202.358,1244.515z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015356457079367415180000001933255668532604841_",
    gradientUnits: "userSpaceOnUse",
    x1: 2315.915,
    y1: 2320.0488,
    x2: 2641.2876,
    y2: 893.9425,
    gradientTransform: "matrix(1 0 -0.1238 0.9835 -169.9759 -22.8047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015356457079367415180000001933255668532604841_)"
    },
    d: "M2212.908,1454.989l-74,0.833 l82.901-397.101c1.051-5.034,8.12-5.32,7.908-0.317L2212.908,1454.989z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084529968656816294170000005987446624674655112_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.9085,
    y1: 2368.7217,
    x2: 1935.5327,
    y2: 2368.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084529968656816294170000005987446624674655112_)"
    },
    d: "M1859.794,2703.242 c-6.713,2.103-13.924,3.078-21.415,2.701c-30.964-1.559-56.127-26.53-57.896-57.482c-1.298-22.708,9.806-42.91,27.161-54.482 c9.076-6.052,12.11-17.979,7.085-27.662c-48.183-92.853-101.64-192.178-145.934-265.21 c-94.125-155.191-206.185-328.935-245.865-390.114c-9.252-14.265-24.948-23.019-41.945-23.411l-502.539-11.577 c-19.473-0.448-37.757,9.28-48.276,25.673c-47.865,74.594-183.27,301.38-269.509,603.5 c-33.114,116.008,43.34,234.745,162.524,253.443l655.453,102.828l537.209-29.919c14.881-0.829,24.1-16.559,17.534-29.939 c-9.842-20.055-24.469-49.696-42.275-85.278C1885.348,2704.805,1872.076,2699.395,1859.794,2703.242z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1105.194,2238c-71.75-113.31-161.641-251.307-200.309-310.489 c-8.148-12.47,0.912-28.983,15.807-28.788c97.3,1.27,372.586,5.048,499.935,8.721l-0.239-0.369 c-7.661-11.804-20.66-19.059-34.728-19.383l-507.212-11.684c-19.473-0.448-37.757,9.28-48.276,25.673 c-50.726,79.053-199.774,329.04-284.42,658.478c-22.577,87.868,35.112,176.137,124.738,190.198l708.149,111.095l43.45-2.42 c-36.109-171.803-130.32-332.391-138.525-346.036C1273.362,2496.029,1199.307,2386.625,1105.194,2238z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145767611976234642990000003693425291632053437_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.3855,
    y1: 2319.0457,
    x2: 1259.6428,
    y2: 2796.0132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000145767611976234642990000003693425291632053437_)"
    },
    cx: 1439.394,
    cy: 2433.867,
    rx: 90.608,
    ry: 77.466
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137813483510470586530000015960025283293463960_",
    gradientUnits: "userSpaceOnUse",
    x1: 1474.5808,
    y1: 2006.9624,
    x2: 1404.9509,
    y2: 2532.6702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137813483510470586530000015960025283293463960_)"
    },
    d: "M1411.613,2415.521 c-27.353,0-50.84,13.838-61.06,33.61c8.292,35.473,44.911,62.203,88.841,62.203c7.19,0,14.174-0.738,20.88-2.09 c11.073-9.956,17.859-23.303,17.859-37.985C1478.134,2440.475,1448.351,2415.521,1411.613,2415.521z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151525021384223815290000004522177216640653465_",
    gradientUnits: "userSpaceOnUse",
    x1: 1183.8265,
    y1: 2109.1587,
    x2: 1002.7791,
    y2: 2279.374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151525021384223815290000004522177216640653465_)"
    },
    d: "M1126.086,2098.73 c-12.57,4.901-14.769,25.666-15.108,28.861c-3.719,35.107,27.587,74.177,46.04,70.227c15.06-3.224,25.922-36.033,17.409-61.51 C1166.625,2112.958,1141.526,2092.711,1126.086,2098.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070834155906138121910000017009460060259630756_",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.5706,
    y1: 1937.7806,
    x2: 1252.9032,
    y2: 2522.6755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070834155906138121910000017009460060259630756_)"
    },
    d: "M1237.511,1931.593 c-16.352,19.812-7.383,56.475,6.956,78.449c19.238,29.482,59.002,49.166,97.082,35.743 c33.683-11.874,58.957-47.153,53.386-74.276C1384.65,1921.441,1268.265,1894.33,1237.511,1931.593z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023243438802088608820000010193787860846726845_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.2839,
    y1: 2198.0952,
    x2: 998.4471,
    y2: 2198.0952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023243438802088608820000010193787860846726845_)"
    },
    d: "M871.667,2102.669 c-15.893,2.022-69.873,8.889-89.363,49.904c-21.14,44.488,7.448,109.89,59.189,133.465 c54.375,24.774,120.279-3.043,145.07-51.065c13.183-25.536,18.75-64.55-1.161-95.166 C954.406,2092.144,885.153,2100.954,871.667,2102.669z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029756564140950304340000014246667794278404249_",
    gradientUnits: "userSpaceOnUse",
    x1: 1176.4749,
    y1: 2410.0247,
    x2: 894.4724,
    y2: 2166.3186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029756564140950304340000014246667794278404249_)"
    },
    d: "M985.403,2139.807 c-19.08-29.341-52.646-37.271-78.788-38.64c-15.524,9.195-31.656,22.991-40.75,43.282 c-19.183,42.801-2.198,103.622,47.357,147.086c31.35-8.133,59.117-29.009,73.342-56.562 C999.746,2209.438,1005.313,2170.423,985.403,2139.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173138661599336972120000016385280672887539607_",
    gradientUnits: "userSpaceOnUse",
    x1: 1206.3246,
    y1: 2066.4033,
    x2: 1118.1221,
    y2: 2165.4377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173138661599336972120000016385280672887539607_)"
    },
    d: "M1112.106,2120.448 c-0.732,3.419-1.021,6.143-1.127,7.143c-2.711,25.592,13.19,53.27,29.156,64.874 C1156.817,2152.525,1128.488,2129.774,1112.106,2120.448z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078007819279516263340000002282571796141423511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1432.7361,
    y1: 1730.2308,
    x2: 1324.8093,
    y2: 1946.0841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078007819279516263340000002282571796141423511_)"
    },
    d: "M1378.639,2003.214 c0-34.816-38.18-63.04-85.278-63.04c-25.817,0-48.937,8.493-64.575,21.891c0.574,16.776,7.183,34.955,15.68,47.977 c19.238,29.482,59.002,49.166,97.082,35.743c11.772-4.15,22.51-11.163,31.27-19.684 C1376.562,2019.004,1378.639,2011.29,1378.639,2003.214z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078008172804173724990000010090133050249780645_",
    gradientUnits: "userSpaceOnUse",
    x1: 694.0567,
    y1: 2463.4268,
    x2: 829.1221,
    y2: 2463.4268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078008172804173724990000010090133050249780645_)"
    },
    d: "M752.391,2403.577 c-9.619,1.268-42.289,5.575-54.085,31.299c-12.795,27.902,4.507,68.921,35.823,83.707c32.909,15.538,72.796-1.909,87.801-32.027 c7.979-16.016,11.348-40.485-0.703-59.687C802.467,2396.976,760.553,2402.501,752.391,2403.577z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119076081295429375910000016228778274306138760_",
    gradientUnits: "userSpaceOnUse",
    x1: 939.7346,
    y1: 2594.375,
    x2: 765.6375,
    y2: 2443.9207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119076081295429375910000016228778274306138760_)"
    },
    d: "M821.227,2426.869 c-11.548-18.402-31.863-23.375-47.685-24.234c-9.396,5.767-19.159,14.419-24.663,27.146c-11.61,26.844-1.33,64.99,28.662,92.25 c18.974-5.101,35.78-18.194,44.389-35.475C829.908,2470.54,833.277,2446.071,821.227,2426.869z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182528475410307180260000018230614300312518800_",
    gradientUnits: "userSpaceOnUse",
    x1: 2386.7617,
    y1: 1548.1116,
    x2: 2394.4204,
    y2: 1839.1477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182528475410307180260000018230614300312518800_)"
    },
    d: "M2538.863,1649.782l0.003,0.093h-0.022 h-19.06c-25.637,15.146-74.526,25.387-130.659,25.387c-0.004,0-0.008,0-0.011,0c-0.004,0-0.007,0-0.011,0 c-56.133,0-105.022-10.241-130.659-25.387h-19.06h-0.021v-0.109c-1.856-7.542-1.522-18.214,0-25.801v-4.093h1.025h0.015 c8.632-24.685,71.895-43.851,148.7-43.851c0.004,0,0.007,0,0.011,0c0.003,0,0.007,0,0.011,0 c76.806,0,140.069,19.167,148.7,43.851h0.015c0.041,0.126,0.077,0.269,0.116,0.399c0.08,0.246,0.147,0.494,0.216,0.741 C2540.257,1628.541,2540.979,1641.2,2538.863,1649.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005972928772360227860000015157646792341812663_",
    gradientUnits: "userSpaceOnUse",
    x1: 2387.5266,
    y1: 1733.4474,
    x2: 2390.9736,
    y2: 1550.7523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000005972928772360227860000015157646792341812663_)"
    },
    cx: 2389.125,
    cy: 1648.721,
    rx: 149.741,
    ry: 42.697
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101101561545883956330000018396932236410956728_",
    gradientUnits: "userSpaceOnUse",
    x1: 2188.697,
    y1: 1710.192,
    x2: 2286.9045,
    y2: 1710.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101101561545883956330000018396932236410956728_)"
    },
    d: "M2259.501,1651.446l-62.347,35.194 c-4.277,2.415-7.267,6.597-8.17,11.427c-0.906,4.828,0.361,9.821,3.48,13.616c17.134,20.863,49.702,55.447,78.582,57.215 C2312.537,1771.439,2259.501,1651.446,2259.501,1651.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2581.143,2145.859c-36.875-13.262-61.416-48.292-61.416-87.479v-402.348h-1.454 c0.212-0.762,0.358-1.528,0.358-2.304c0-18.003-57.982-32.597-129.505-32.597c-71.524,0-129.506,14.594-129.506,32.597 c0,0.776,0.146,1.542,0.358,2.304h-1.239v402.348c0,39.187-24.541,74.217-61.416,87.479 c-240.066,86.339-413.107,323.254-413.107,541.619c0,273.218,270.875,413.871,605.016,413.871s605.016-140.653,605.016-413.871 C2994.249,2469.113,2821.208,2232.198,2581.143,2145.859z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075143671146815156900000009697467103319601342_",
    gradientUnits: "userSpaceOnUse",
    x1: 1803.5505,
    y1: 2351.5735,
    x2: 2974.916,
    y2: 2351.5735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075143671146815156900000009697467103319601342_)"
    },
    d: "M2389.233,3082.016 c-82.522,0-160.231-8.649-230.967-25.707c-71.613-17.27-134.362-42.763-186.501-75.774 c-53.571-33.915-95.08-75.295-123.375-122.99c-29.753-50.154-44.839-107.373-44.839-170.067 c0-102.584,40.003-212.212,112.64-308.691c74.084-98.4,176.249-174.662,287.675-214.736 c44.385-15.963,74.207-58.429,74.207-105.671l2.284-420.57c11.904-6.707,50.205-16.679,108.768-16.679 c58.572,0,96.875,9.975,108.773,16.682l2.494,420.566c0,47.242,29.822,89.708,74.207,105.671 c111.426,40.074,213.591,116.335,287.675,214.736c72.637,96.479,112.641,206.107,112.641,308.691 c0,62.694-15.086,119.913-44.84,170.067c-28.294,47.695-69.803,89.075-123.374,122.99 c-52.14,33.01-114.888,58.504-186.502,75.774C2549.464,3073.367,2471.755,3082.016,2389.233,3082.016z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066481345320182142270000012830828343137244325_",
    gradientUnits: "userSpaceOnUse",
    x1: 2678.032,
    y1: 1788.9379,
    x2: 2566.2622,
    y2: 3216.5295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066481345320182142270000012830828343137244325_)"
    },
    d: "M2870.664,1944.181 c-44.644-103.072-136.466-169.832-265.583-193.067c-54.296-9.755-103.578-9.62-135.62-7.758c-0.982,0.068-1.965,0.132-2.914,0.2 c-5.385,0.711-10.277,3.617-14.749,8.291c-5.792,5.962-10.552,14.757-13.939,25.461v0.058h-0.119 c-3.453,10.161-5.51,23.606-5.51,37.29c0,30.722,10.029,56.833,24.186,66.859c3.49,2.438,7.184,4.239,11.048,4.239 c0.033,0,0.033,0,0.033,0c0.575,0,1.118,0.119,1.694,0.119c0.645,0,1.287-0.119,1.895-0.119h0.103 c47.452-3.387,204.447-7.52,255.796,111.029c50.807,117.364-20.594,209.663-91.012,267.141c-0.036,0.031-0.073,0.058-0.109,0.089 c-5.001,1.169-9.159,3.437-12.053,7.004c-12.877,15.862,3.106,50.162,35.694,76.61c26.072,21.158,54.839,30.838,71.906,25.757 l0.01,0.01l1.492,1.56l1.489-1.186C2886.449,2251.865,2936.101,2095.277,2870.664,1944.181z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019648835708726694760000014310934798065490591_",
    gradientUnits: "userSpaceOnUse",
    x1: 2435.0266,
    y1: 2606.0842,
    x2: 2851.6216,
    y2: 4125.1274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1F094"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FC3BA"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000019648835708726694760000014310934798065490591_)"
    },
    cx: 2379.381,
    cy: 2403.18,
    rx: 375.07,
    ry: 51.606
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051355018247450678200000016596447207068474031_",
    gradientUnits: "userSpaceOnUse",
    x1: 2364.063,
    y1: 2625.5447,
    x2: 2780.6577,
    y2: 4144.5874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1F094"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FC3BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051355018247450678200000016596447207068474031_)"
    },
    d: "M2754.451,2403.167l-345.789-24.15 l-0.169-4.063l-29.095,2.031l-29.131-2.031l-0.168,4.063l-345.789,24.082c0,0-358.695,529.27,322.453,597.011 c0.003,0,0.01,0,0.013,0c34.443,3.387,70.167,3.571,104.61,0.129c0.205-0.021,0.407-0.007,0.612-0.028 C3113.146,2931.215,2754.451,2403.167,2754.451,2403.167z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2993.968,2673.962c-0.02-0.754-0.059-1.51-0.083-2.265c-0.104-3.124-0.229-6.249-0.401-9.379 c-0.031-0.571-0.071-1.144-0.104-1.716c-0.203-3.426-0.438-6.854-0.722-10.285c-0.021-0.261-0.044-0.522-0.066-0.782 c-0.32-3.781-0.683-7.563-1.099-11.349c-0.001-0.006-0.001-0.011-0.002-0.017c-93.76,104.774-289.678,281.849-549.98,280.974 c-67.572-0.227-207.07-0.696-314.371-104.791c-64.94-63-145.888-190.924-106.768-296.577 c59.343-160.271,347.803-141.866,367.755-274.827c9.073-60.461-49.534-71.195-63.269-175.969 c-15.144-115.519,48.375-161.392,47.452-266.919c-0.28-32.071-22.32-115.933-49.379-176.648 c-37.97,5.683-63.428,16.107-63.428,28.034c0,0.776,0.146,1.542,0.358,2.304h-1.238v402.348l0,0 c0,17.145-4.698,33.493-13.07,47.572c-0.598,1.005-1.215,2-1.85,2.981c-1.27,1.964-2.614,3.879-4.028,5.741 c-3.536,4.656-7.512,8.982-11.884,12.912c-1.748,1.571-3.56,3.08-5.431,4.52c-0.936,0.72-1.887,1.424-2.852,2.109 c-6.758,4.8-14.235,8.743-22.301,11.644c-240.066,86.338-413.107,323.254-413.107,541.619c0,17.076,1.058,33.634,3.123,49.673 c2.066,16.039,5.139,31.558,9.168,46.554c2.015,7.498,4.269,14.866,6.756,22.104c4.974,14.475,10.879,28.427,17.665,41.854 c15.268,30.211,34.995,57.766,58.603,82.641c20.985,22.112,45.036,42.106,71.749,59.969c3.339,2.232,6.72,4.432,10.141,6.598 c109.486,69.315,260.74,104.479,427.811,104.479s318.325-35.163,427.811-104.479c3.422-2.166,6.802-4.366,10.141-6.598 c26.713-17.863,50.764-37.857,71.749-59.969c23.608-24.875,43.334-52.43,58.603-82.641c6.786-13.427,12.691-27.379,17.665-41.854 c2.487-7.237,4.741-14.605,6.756-22.104c4.03-14.997,7.103-30.515,9.168-46.554c2.065-16.039,3.124-32.597,3.124-49.673 C2994.131,2681.457,2994.072,2677.711,2993.968,2673.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176759601203530509070000000099112639838270882_",
    gradientUnits: "userSpaceOnUse",
    x1: 1395.7441,
    y1: 2175.9163,
    x2: 1348.2837,
    y2: 2813.7903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176759601203530509070000000099112639838270882_)"
    },
    d: "M1550.909,2584.841 c0,131.546-83.08,202.594-185.565,202.594s-185.565-71.048-185.565-202.594s83.08-273.776,185.565-273.776 S1550.909,2453.295,1550.909,2584.841z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137125291675379135910000013207511416067828409_",
    gradientUnits: "userSpaceOnUse",
    x1: 1281.9655,
    y1: 2804.0444,
    x2: 1517.3713,
    y2: 2166.1719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137125291675379135910000013207511416067828409_)"
    },
    d: "M1432.804,2653.917 c-22.576-8.597-22.382-36.195-68.344-91.125c-42.602-50.914-67.66-56.95-83.531-79.734 c-16.942-24.322-22.871-66.984,11.831-147.46c-66.412,46.294-112.981,150.76-112.981,249.243 c0,131.546,83.08,202.594,185.565,202.594s185.565-71.048,185.565-202.594c0-0.198-0.006-0.397-0.006-0.595 C1488.124,2651.914,1453.416,2661.766,1432.804,2653.917z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144300405114361171240000004642594633607811773_",
    gradientUnits: "userSpaceOnUse",
    x1: 1016.7854,
    y1: 2147.7195,
    x2: 969.325,
    y2: 2785.5935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144300405114361171240000004642594633607811773_)"
    },
    d: "M1169.853,2584.841 c0,131.546-83.08,202.594-185.565,202.594c-102.484,0-185.564-71.048-185.564-202.594s83.08-273.776,185.564-273.776 C1086.773,2311.066,1169.853,2453.295,1169.853,2584.841z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062873191720000324760000010072214383702980014_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.9088,
    y1: 2804.0444,
    x2: 1136.3147,
    y2: 2166.1719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062873191720000324760000010072214383702980014_)"
    },
    d: "M1051.748,2653.917 c-22.577-8.597-22.382-36.195-68.344-91.125c-42.602-50.914-67.66-56.95-83.531-79.734 c-16.942-24.322-22.871-66.984,11.831-147.46c-66.412,46.294-112.98,150.76-112.98,249.243 c0,131.546,83.08,202.594,185.564,202.594c102.484,0,185.565-71.048,185.565-202.594c0-0.198-0.006-0.397-0.006-0.595 C1107.067,2651.914,1072.359,2661.766,1051.748,2653.917z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081624426416376473400000009366107023615788684_",
    gradientUnits: "userSpaceOnUse",
    x1: 1156.5172,
    y1: 2752.0583,
    x2: 1156.5172,
    y2: 2723.5818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000081624426416376473400000009366107023615788684_)"
    },
    points: "493.182,2681.727  872.818,2874.911 1819.853,2697.103 1411.599,2672.732  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1723.139,2624.708c0,131.546-83.08,202.594-185.565,202.594 c-102.484,0-185.565-71.048-185.565-202.594s83.08-273.776,185.565-273.776 C1640.058,2350.933,1723.139,2493.163,1723.139,2624.708z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057114079157117540470000007321418672544171145_",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.1945,
    y1: 2843.9116,
    x2: 1689.6002,
    y2: 2206.0391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057114079157117540470000007321418672544171145_)"
    },
    d: "M1605.033,2693.785 c-22.576-8.597-22.382-36.196-68.344-91.125c-42.602-50.914-67.66-56.95-83.531-79.734 c-16.942-24.322-22.871-66.984,11.831-147.46c-66.412,46.294-112.98,150.76-112.98,249.243 c0,131.546,83.08,202.594,185.564,202.594c102.484,0,185.565-71.048,185.565-202.594c0-0.198-0.005-0.397-0.006-0.595 C1660.353,2691.781,1625.645,2701.633,1605.033,2693.785z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1342.082,2624.708c0,131.546-83.08,202.594-185.565,202.594 c-102.485,0-185.565-71.048-185.565-202.594s83.08-273.776,185.565-273.776 C1259.002,2350.933,1342.082,2493.163,1342.082,2624.708z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108301137958557607040000018095437277862618787_",
    gradientUnits: "userSpaceOnUse",
    x1: 1073.1377,
    y1: 2843.9114,
    x2: 1308.5435,
    y2: 2206.0391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108301137958557607040000018095437277862618787_)"
    },
    d: "M1223.977,2693.785 c-22.576-8.597-22.382-36.196-68.344-91.125c-42.602-50.914-67.659-56.95-83.531-79.734 c-16.942-24.322-22.871-66.984,11.831-147.46c-66.412,46.294-112.98,150.76-112.98,249.243 c0,131.546,83.08,202.594,185.564,202.594c102.484,0,185.565-71.048,185.565-202.594c0-0.198-0.005-0.397-0.006-0.595 C1279.297,2691.781,1244.588,2701.633,1223.977,2693.785z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M961.025,2624.708c0,131.546-83.08,202.594-185.565,202.594s-185.565-71.048-185.565-202.594 s83.08-273.776,185.565-273.776S961.025,2493.163,961.025,2624.708z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121248552190956487570000009361705452653211318_",
    gradientUnits: "userSpaceOnUse",
    x1: 692.0811,
    y1: 2843.9116,
    x2: 927.4868,
    y2: 2206.0391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121248552190956487570000009361705452653211318_)"
    },
    d: "M842.92,2693.785 c-22.576-8.597-22.382-36.196-68.344-91.125c-42.602-50.914-67.659-56.95-83.531-79.734 c-16.942-24.322-22.871-66.984,11.831-147.46c-66.412,46.294-112.98,150.76-112.98,249.243 c0,131.546,83.08,202.594,185.565,202.594c102.484,0,185.565-71.048,185.565-202.594c0-0.198-0.006-0.397-0.006-0.595 C898.24,2691.781,863.531,2701.633,842.92,2693.785z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027591572711556302150000005737979271827729837_",
    gradientUnits: "userSpaceOnUse",
    x1: 806.4708,
    y1: 2859.1741,
    x2: 544.4871,
    y2: 2806.0181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027591572711556302150000005737979271827729837_)"
    },
    d: "M493.182,2681.727 c-8.379-0.968-15.235,6.572-13.478,14.822l37.992,178.363c6.654,29.727,29.277,53.293,58.707,61.157l296.72,76.223 l-85.742-296.584L493.182,2681.727z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143599720246308225720000010639866220440831106_",
    gradientUnits: "userSpaceOnUse",
    x1: 787.3805,
    y1: 2856.3252,
    x2: 1824.6835,
    y2: 2856.3252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143599720246308225720000010639866220440831106_)"
    },
    d: "M1694.29,2968.063l-793.317,48.723 c-32.348,1.987-61.107-20.439-67.065-52.296l-46.528-248.783l1027.325-19.962c6.745-0.131,11.594,6.445,9.475,12.85 l-70.758,213.92C1744.875,2948.357,1721.458,2966.394,1694.29,2968.063z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173863054198701767220000000730912215759983233_",
    gradientUnits: "userSpaceOnUse",
    x1: 1449.62,
    y1: 2964.5149,
    x2: 1978.6749,
    y2: 2524.5356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173863054198701767220000000730912215759983233_)"
    },
    d: "M1844.294,2760.257 c-14.47-36.593-34.81-70.571-62.435-98.752c-27.407-27.959-61.76-46.897-98.733-59.028 c-93.456-30.663-207.916-21.615-294.151,24.847c-111.078,62.066-149.634,135.936-157.097,215.345 c-6.974,74.205,13.292,146.325,59.056,205.356c22.647,29.213,50.395,54.016,82.606,72.253 c34.206,19.367,73.152,29.599,112.094,33.4c136.302,13.303,322.685-24.624,372.31-173.282 C1881.778,2908.999,1871.492,2829.039,1844.294,2760.257z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037661358135206331470000010427292938650548390_",
    gradientUnits: "userSpaceOnUse",
    x1: 1410.261,
    y1: 2997.2319,
    x2: 1785.1003,
    y2: 2685.5034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000037661358135206331470000010427292938650548390_)"
    },
    d: "M1819.744,3014.239 c-26.993-13.496-24.293-51.286-45.887-67.481c-43.188-32.391-102.572,5.398-153.858,10.797 c-89.076,8.098-161.955-48.587-210.542-116.068c-40.489-56.684-13.496-129.564,5.399-191.647 c4.696-14.759,10.73-28.681,17.761-42.021c-15.138,5.53-29.759,12.025-43.641,19.505 c-111.078,62.067-149.633,135.936-157.096,215.345c-6.974,74.206,13.292,146.325,59.055,205.357 c22.647,29.212,50.395,54.015,82.607,72.253c34.205,19.366,73.151,29.598,112.093,33.399 c124.237,12.126,290.062-18.328,356.028-136.385C1834.209,3017.521,1826.752,3016.574,1819.744,3014.239z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109733533645039828190000007288720032974763196_",
    gradientUnits: "userSpaceOnUse",
    x1: 1574.5986,
    y1: 2864.5662,
    x2: 1915.5649,
    y2: 2581.0076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109733533645039828190000007288720032974763196_)"
    },
    d: "M1844.294,2760.258 c-14.47-36.594-34.811-70.572-62.435-98.752c-27.406-27.96-61.76-46.898-98.734-59.029 c-78.412-25.726-171.602-23.484-250.509,5.342c-7.031,13.34-13.065,27.261-17.761,42.021 c-18.895,62.083-45.887,134.963-5.399,191.647c48.587,67.481,121.467,124.166,210.542,116.068 c51.286-5.399,110.67-43.188,153.858-10.797c21.594,16.196,18.895,53.985,45.887,67.481c7.008,2.335,14.465,3.283,21.918,3.054 c6.405-11.465,11.89-23.739,16.282-36.897C1881.778,2908.999,1871.491,2829.039,1844.294,2760.258z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006682046641653194960000018159727462909575615_",
    gradientUnits: "userSpaceOnUse",
    x1: 1265.6399,
    y1: 2920.7922,
    x2: 1067.9016,
    y2: 3225.7788,
    gradientTransform: "matrix(0.9475 -0.3199 0.3199 0.9475 -424.9468 -26.4853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006682046641653194960000018159727462909575615_)"
    },
    d: "M1396.629,2703.278 c0,0,33.306-28.67,82.736-32.232c64.594-4.654,85.455,21.694,85.455,21.694s7.629-10.542-40.055-61.342 c-47.685-50.8-22.756-116.343-22.756-116.343s12.916,49.166,34.422,80.282s56.963,25.788,70.967,73.252 c0,0,28.352-30.933,18.86-60.305s3.585-73.729,3.585-73.729s5.555,31.871,35.118,69.807 c29.563,37.936-2.808,84.514-13.141,97.816c0,0,28.281-20.302,72.436,3.018s115.203-25.78,115.203-25.78 s-34.326,51.436-73.913,57.434c-81.262,18.382-120.777-5.282-120.777-5.282s-14.432,10.163,36.748,49.35 c51.18,39.187-1.928,100.994-1.928,100.994s-0.49-59.916-37.552-87.665c-37.063-27.749-52.409-42.104-52.409-42.104 s-88.847,13.924-79.855,71.711c7.263,34.926,30.381,71.229,30.381,71.229s-74.207-27.916-70.321-80.346 c3.885-52.43,70.112-88.982,70.112-88.982s-29.554-19.907-63.865-24.367S1396.629,2703.278,1396.629,2703.278z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001628094521175476890000014381003636900040354_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.8994,
    y1: 3035.8354,
    x2: 1147.8994,
    y2: 3521.7937,
    gradientTransform: "matrix(0.9475 -0.3199 0.3199 0.9475 -424.9468 -26.4853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001628094521175476890000014381003636900040354_)"
    },
    d: "M1589.987,2711.638 c0,0,78.822-131.476,178.24-155.987c25.625,11.663,19.552,41.028,19.552,41.028s-119.864,53.451-162.525,120.918 C1607.848,2743.175,1589.987,2711.638,1589.987,2711.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165951309074919115250000014679107339610002845_",
    gradientUnits: "userSpaceOnUse",
    x1: 4611.6577,
    y1: 2686.5771,
    x2: 4677.4839,
    y2: 2395.0417,
    gradientTransform: "matrix(-0.9998 -0.0216 0.0216 -0.9998 7140.3159 5617.9727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165951309074919115250000014679107339610002845_)"
    },
    d: "M2854.81,2898.933 c3.54,0.077,6.591,2.728,7.063,6.346c0.519,3.995-2.295,7.652-6.287,8.173c-4.137,0.54-415.758,54.887-604.07,141.646 c-3.65,1.685-7.988,0.088-9.673-3.573c-1.685-3.656-0.086-7.988,3.573-9.672c190.323-87.684,604.127-142.319,608.283-142.861 C2854.074,2898.943,2854.445,2898.925,2854.81,2898.933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106841873996293429480000009054744767296094893_",
    gradientUnits: "userSpaceOnUse",
    x1: 2556.9146,
    y1: 1094.318,
    x2: 2701.0178,
    y2: 1094.318,
    gradientTransform: "matrix(-1.1005 0.7775 -1.0102 -1.4299 6498.5933 2613.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106841873996293429480000009054744767296094893_)"
    },
    d: "M2335.469,3008.317 c9.783-21.454,64.18-13.403,64.18-13.403c206.84-11.067,266.134,184.979,266.134,184.979 c-144.986,64.253-310.256-124.453-310.256-124.453C2335.318,3032.263,2331.253,3017.538,2335.469,3008.317z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155832925609204778710000014378010455978363816_",
    gradientUnits: "userSpaceOnUse",
    x1: 2565.5715,
    y1: 1093.6608,
    x2: 2701.0178,
    y2: 1093.6608,
    gradientTransform: "matrix(-1.1005 0.7775 -1.0102 -1.4299 6498.5933 2613.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000155832925609204778710000014378010455978363816_)"
    },
    d: "M2335.469,3008.317 c126.348,64.532,330.314,171.576,330.314,171.576c-144.986,64.253-310.256-124.453-310.256-124.453 C2335.318,3032.263,2331.253,3017.538,2335.469,3008.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047053698162545604910000011233618375826381956_",
    gradientUnits: "userSpaceOnUse",
    x1: 1463.3687,
    y1: 1490.458,
    x2: 1607.4711,
    y2: 1490.458,
    gradientTransform: "matrix(0.5623 1.2245 -1.591 0.7306 3959.3701 -105.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047053698162545604910000011233618375826381956_)"
    },
    d: "M2337.806,3009.727 c-19.294-13.554-1.395-65.55-1.395-65.55c27.085-205.357,230.684-227.661,230.684-227.661 c36.55,154.316-179.285,282.143-179.285,282.143C2361.318,3014.27,2346.097,3015.563,2337.806,3009.727z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062177431778234056690000003399428485250897315_",
    gradientUnits: "userSpaceOnUse",
    x1: 1472.0264,
    y1: 1489.8007,
    x2: 1607.4711,
    y2: 1489.8007,
    gradientTransform: "matrix(0.5623 1.2245 -1.591 0.7306 3959.3701 -105.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000062177431778234056690000003399428485250897315_)"
    },
    d: "M2337.806,3009.727 c86.626-112.357,229.289-293.21,229.289-293.21c36.55,154.316-179.285,282.143-179.285,282.143 C2361.318,3014.27,2346.097,3015.563,2337.806,3009.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065062458386152054570000014189926115359596931_",
    gradientUnits: "userSpaceOnUse",
    x1: 2353.6973,
    y1: 1032.3732,
    x2: 2477.7778,
    y2: 1032.3732,
    gradientTransform: "matrix(-1.1005 0.7775 -1.0102 -1.4299 6498.5933 2613.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065062458386152054570000014189926115359596931_)"
    },
    d: "M2655.556,2942.899 c8.423-18.474,55.262-11.541,55.262-11.541c178.1-9.529,229.155,159.277,229.155,159.277 c-124.84,55.325-267.147-107.161-267.147-107.161C2655.426,2963.518,2651.926,2950.838,2655.556,2942.899z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021816394678893954740000013216355152328635060_",
    gradientUnits: "userSpaceOnUse",
    x1: 2361.1514,
    y1: 1031.8073,
    x2: 2477.7778,
    y2: 1031.8073,
    gradientTransform: "matrix(-1.1005 0.7775 -1.0102 -1.4299 6498.5933 2613.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000021816394678893954740000013216355152328635060_)"
    },
    d: "M2655.556,2942.899 c108.792,55.565,284.417,147.736,284.417,147.736c-124.84,55.325-267.147-107.161-267.147-107.161 C2655.426,2963.518,2651.926,2950.838,2655.556,2942.899z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119078936322978245280000005826841223229683117_",
    gradientUnits: "userSpaceOnUse",
    x1: 1536.962,
    y1: 1321.8696,
    x2: 1661.0417,
    y2: 1321.8696,
    gradientTransform: "matrix(0.5623 1.2245 -1.591 0.7306 3959.3701 -105.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119078936322978245280000005826841223229683117_)"
    },
    d: "M2657.569,2944.112 c-16.614-11.671-1.201-56.441-1.201-56.441c23.322-176.823,198.631-196.028,198.631-196.028 c31.471,132.874-154.374,242.939-154.374,242.939C2677.813,2948.025,2664.707,2949.138,2657.569,2944.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065796887270456802070000012675635541409540006_",
    gradientUnits: "userSpaceOnUse",
    x1: 1544.4167,
    y1: 1321.3037,
    x2: 1661.0417,
    y2: 1321.3037,
    gradientTransform: "matrix(0.5623 1.2245 -1.591 0.7306 3959.3701 -105.4198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000065796887270456802070000012675635541409540006_)"
    },
    d: "M2657.569,2944.112 c74.59-96.746,197.429-252.469,197.429-252.469c31.471,132.874-154.374,242.939-154.374,242.939 C2677.813,2948.025,2664.707,2949.138,2657.569,2944.112z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139283070195767407550000000373209850618652313_",
    gradientUnits: "userSpaceOnUse",
    x1: 2053.5935,
    y1: 1199.4121,
    x2: 2177.6724,
    y2: 1199.4121,
    gradientTransform: "matrix(-0.3251 1.3076 -1.699 -0.4224 5713.1431 614.6121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139283070195767407550000000373209850618652313_)"
    },
    d: "M2832.596,2911.588 c-5.693-19.489,34.296-44.843,34.296-44.843c128.603-123.578,277.546-29.142,277.546-29.142 c-58.362,123.449-272.257,93.419-272.257,93.419C2845.969,2927.282,2835.036,2919.97,2832.596,2911.588z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093887330736311942810000006065908942003371931_",
    gradientUnits: "userSpaceOnUse",
    x1: 2061.0498,
    y1: 1198.8462,
    x2: 2177.6724,
    y2: 1198.8462,
    gradientTransform: "matrix(-0.3251 1.3076 -1.699 -0.4224 5713.1431 614.6121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24ABB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40CF9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000093887330736311942810000006065908942003371931_)"
    },
    d: "M2832.596,2911.588 c118.665-29.016,311.842-73.985,311.842-73.985c-58.362,123.449-272.257,93.419-272.257,93.419 C2845.969,2927.282,2835.036,2919.97,2832.596,2911.588z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176725651261949757410000004121308145964827039_",
    gradientUnits: "userSpaceOnUse",
    x1: 3860.4954,
    y1: 2100.6938,
    x2: 3812.4094,
    y2: 2714.8784,
    gradientTransform: "matrix(-0.1632 -0.9866 0.9866 -0.1632 392.2651 7203.1982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176725651261949757410000004121308145964827039_)"
    },
    d: "M1934.401,2936.27 c72.211-11.943,138.544,25.504,148.159,83.64c9.615,58.136-41.13,114.945-113.341,126.888s-138.544-25.504-148.159-83.64 C1811.446,3005.022,1862.19,2948.213,1934.401,2936.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074434512823057972580000007988001931703578284_",
    gradientUnits: "userSpaceOnUse",
    x1: 3806.5815,
    y1: 2096.5002,
    x2: 3758.53,
    y2: 2710.2446,
    gradientTransform: "matrix(-0.1632 -0.9866 0.9866 -0.1632 392.2651 7203.1982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000074434512823057972580000007988001931703578284_)"
    },
    d: "M1968.406,3098.869 c-62.311,10.305-120.12-8.4-148.25-43.712c0.191,2.664,0.464,5.328,0.906,8c9.614,58.134,75.948,95.583,148.158,83.64 c67.41-11.148,116.093-61.396,114.45-115.323C2061.896,3064.203,2019.766,3090.375,1968.406,3098.869z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1943.431,2961.045c46.315-7.717,82.056,13.603,78.772,26.088 c-2.866,12.926-35.041,14.854-70.945,21.235c-36.054,5.517-67.121,14.061-74.005,2.738 C1870.135,3000.34,1897.096,2968.651,1943.431,2961.045z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052785718362868452490000013585738197308007582_",
    gradientUnits: "userSpaceOnUse",
    x1: 2793.7378,
    y1: 3886.4219,
    x2: 2745.6511,
    y2: 4500.6133,
    gradientTransform: "matrix(0.6384 0.7697 -0.7697 0.6384 3492.7549 -1620.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052785718362868452490000013585738197308007582_)"
    },
    d: "M2257.015,3160.919 c-56.339,46.722-132.504,47.828-170.119,2.471c-37.615-45.357-22.436-120.003,33.903-166.725 c56.339-46.722,132.504-47.828,170.119-2.471C2328.533,3039.552,2313.354,3114.197,2257.015,3160.919z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100380321353909300140000016084286049311115954_",
    gradientUnits: "userSpaceOnUse",
    x1: 2174.2117,
    y1: 3092.0308,
    x2: 2153.8921,
    y2: 3351.5652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#893976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311944"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000100380321353909300140000016084286049311115954_)"
    },
    d: "M2270.539,3146.741 c-56.339,46.723-135.531,44.178-176.88-5.683c-15.207-18.336-23.151-40.523-24.35-63.566 c-7.156,31.19-1.852,62.455,17.589,85.896c37.614,45.359,113.779,44.252,170.118-2.471c7.725-6.406,14.645-13.35,20.792-20.657 C2275.462,3142.474,2273.061,3144.651,2270.539,3146.741z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2131.602,3005.394c36.238-29.857,77.85-29.284,81.254-16.831 c3.987,12.625-22.905,30.395-50.798,53.886c-28.455,22.818-51.077,45.762-62.702,39.402 C2087.807,3076.093,2095.292,3035.165,2131.602,3005.394z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcsSupport);
export default __webpack_public_path__ + "static/media/ecs_support.467cfc85868e04e4f02c81e5799689c3.svg";
export { ForwardRef as ReactComponent };